import React from 'react';

const C = {
  bg: '#fbfaf6',
  ink: '#1a2a26',
  inkMuted: '#5a6b65',
  inkFaint: '#8b9690',
  line: '#e8e2d4',
  accent: '#2d6e58',
};

const RefundPage: React.FC = () => (
  <div style={{ background: C.bg, minHeight: '100vh', fontFamily: 'system-ui, sans-serif', color: C.ink }}>
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px' }}>
      <a href="/" style={{ color: C.accent, textDecoration: 'none', fontSize: 14 }}>← Back to Nice Agenda</a>
      <h1 style={{ marginTop: 32, marginBottom: 8, fontSize: 32, fontWeight: 700 }}>Refund Policy</h1>
      <p style={{ color: C.inkFaint, fontSize: 14, marginBottom: 40 }}>Effective date: May 1, 2026</p>

      <Section title="1. Subscription Cancellations">
        You may cancel your Nice Agenda Pro subscription at any time through your account settings.
        Upon cancellation, your subscription will remain active until the end of the current billing period.
        No further charges will be made after that date.
      </Section>

      <Section title="2. Refund Eligibility">
        We offer a full refund if you request it within 14 days of your subscription purchase.
        This applies to both initial purchases and renewal charges.
      </Section>

      <Section title="3. How to Request a Refund">
        To request a refund, please email us at{' '}
        <a href="mailto:pedro@bajotto.com" style={{ color: C.accent }}>pedro@bajotto.com</a>{' '}
        with the subject line "Refund Request" and include your account email address and
        the reason for the request. We will respond within 3 business days.
      </Section>

      <Section title="4. Processing">
        Approved refunds are processed by Paddle, our merchant of record. Refunds are returned to
        the original payment method and typically appear within 5–10 business days depending on
        your bank or card issuer.
      </Section>

      <Section title="5. Free Plan">
        The Free plan has no charges, so no refunds apply.
      </Section>

      <Section title="6. Consumer Rights">
        Nothing in this policy limits any statutory rights you may have under the consumer protection
        laws of your country or region.
      </Section>

      <Section title="7. Contact">
        Questions about this policy? Reach us at{' '}
        <a href="mailto:pedro@bajotto.com" style={{ color: C.accent }}>pedro@bajotto.com</a>.
      </Section>
    </div>
  </div>
);

const Section: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div style={{ marginBottom: 32 }}>
    <h2 style={{ fontSize: 18, fontWeight: 600, color: C.ink, marginBottom: 8 }}>{title}</h2>
    <div style={{ borderTop: `1px solid ${C.line}`, paddingTop: 12 }}>
      <p style={{ color: C.inkMuted, lineHeight: 1.7, margin: 0, fontSize: 15 }}>{children}</p>
    </div>
  </div>
);

export default RefundPage;
